import { useMemo } from 'react';
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter,
} from 'react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { RiArrowUpSFill, RiArrowDownSFill } from 'react-icons/ri';
import { ColumnFilter } from './ColumnFilter';
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from 'react-icons/md';

export const Table = (props) => {
  const columns = useMemo(() => props.columns, [props.columns]);
  const data = useMemo(() => props.data, [props.data]);
  // const tableInstance = useTable({ COLUMNS, MOCK_DATA });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    // rows,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    setGlobalFilter,
    state,
  } = useTable(
    {
      columns: columns,
      data: data,
      disableSortby: true,
      disableSorting: true,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { pageIndex, pageSize, globalFilter } = state;

  const handleExportPDF = () => {
    const orientation = 'landscape';

    const pdf = new jsPDF(orientation);

    const title = 'My Transactions History';
    const headers = [
      ['No', 'Date', 'Trx Type', 'Rate', 'Amount', 'Total', 'Payment'],
    ];

    const rows = data.map((row, index) => [
      index + 1,
      row.date,
      row.transaction_type?.props?.children,
      row.rate,
      row.amount,
      row.total,
      row.payment,
    ]);

    const content = {
      theme: 'grid',
      styles: {
        cellPadding: 4,
        fontSize: 12,
        textColor: '#2C2F30',
      },
      headStyles: {
        fillColor: '#5AC8FA',
        textColor: '#FFFFFF',
        fontSize: 14,
      },
      startY: 15,
      head: headers,
      body: rows,
    };

    pdf.text(title, 15, 10);
    pdf.autoTable(content);
    pdf.save('transaction-history.pdf');
  };

  return (
    <>
      <div
        className={`px-2 md:px-6 my-3 flex w-full gap-4 overflow-hidden ${
          props.showControls ? 'justify-between' : 'justify-center'
        } bg-t-wh py-4 items-center`}
      >
        <div className='w-full'>
          <ColumnFilter filter={globalFilter} setFilter={setGlobalFilter} />
        </div>

        {props.showControls && (
          <div>
            <button
              className='py-1 md:py-2 bg-b-mc h-fit text-p-wh rounded text-sm px-2 md:px-4 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80 flex items-center gap-1'
              onClick={handleExportPDF}
            >
              <span>Download PDF</span>
              <i>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                >
                  <path fill='#fff' d='M9 4h6v8h4.84L12 19.84L4.16 12H9z' />
                </svg>
              </i>
            </button>
          </div>
        )}
      </div>

      <div className='overflow-x-auto'>
        <table
          {...getTableProps()}
          className='w-full h-fit text-sm bg-p-wh shadow-lg'
        >
          <thead className='bg-p-wh'>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className='py-4 px-6 text-center'
                  >
                    <div className='flex flex-row items-center gap-2 justify-center'>
                      {column.render('Header')}
                      <span>
                        {column.isSorted ? (
                          <div className='flex flex-col'>
                            <RiArrowUpSFill />
                            <RiArrowDownSFill className='-mt-2' />
                          </div>
                        ) : (
                          <div className='flex flex-col'>
                            <RiArrowUpSFill />{' '}
                            <RiArrowDownSFill className='-mt-2' />
                          </div>
                        )}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className='w-full '>
            {page.map(
              (row, i) =>
                prepareRow(row) || (
                  <tr {...row.getRowProps()} className='border-t-hf'>
                    {row.cells.map((cell) => {
                      return (
                        <td
                          {...cell.getCellProps()}
                          className='py-6 px-4 text-center'
                        >
                          {cell.render('Cell')}
                        </td>
                      );
                    })}
                  </tr>
                )
            )}
          </tbody>
        </table>
      </div>

      <div className='flex flex-row justify-between pt-8'>
        <div>
          <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span>
          {/* <span>
            | Go to page:{" "}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "100px" }}
            />
          </span> */}
        </div>

        <div className='flex flex-row gap-2 '>
          <div className='flex flex-row items-center gap-1 border-hf rounded px-2 py-1'>
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              <MdOutlineKeyboardArrowLeft />
            </button>{' '}
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              Previous
            </button>{' '}
          </div>
          <div className='flex flex-row items-center border-hf rounded px-2 py-1'>
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              Next
            </button>{' '}
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              <MdOutlineKeyboardArrowRight />
            </button>{' '}
          </div>
        </div>
      </div>
    </>
  );
};
